import React from "react";
import { useFela } from "react-fela";

import { useTheme } from "@/hooks/useTheme";
import { Heading } from "@/components/Heading";
import { Icon, StyledIconWrapper } from "@/components/Icon";

import { IExtractImagesFromXDFeatureItem } from "./types";

type IProps = IExtractImagesFromXDFeatureItem;

export const FeatureItem: React.FC<IProps> = ({
  title,
  description,
  icon,
  iconColor,
}) => {
  const { colors } = useTheme();
  const { css } = useFela();

  return (
    <div
      className={css({
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        width: "100%",
        padding: "48px 32px",
        borderRadius: "10px",
        border: "1px solid #E5E7EB",
      })}
    >
      <StyledIconWrapper
        width={32}
        height={32}
        wrapperStyle={{
          width: "64px",
          height: "64px",
          borderRadius: "32px",
          backgroundColor: `${iconColor}1A`,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        customStyle={{
          color: iconColor,
        }}
      >
        <Icon iconType={icon} />
      </StyledIconWrapper>

      <div className={css({ paddingTop: "32px" })}>
        <Heading
          as="h3"
          customStyle={{
            textAlign: "center",
            fontSize: 24,
            lineHeight: "32px",
            marginBottom: 16,
            color: colors.DARK_GREY,
            fontWeight: 700,
          }}
        >
          {title}
        </Heading>

        <p
          className={css({
            textAlign: "center",
            fontSize: 16,
            lineHeight: "24px",
            color: colors.GRAY,
          })}
        >
          {description}
        </p>
      </div>
    </div>
  );
};
